<template>
  <div>
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <h2 class="page-title mb-md-0 mb-3">
                    <a class="cursor-pointer" v-on:click="$router.go(-1)"
                      ><img
                        src="images/back-arrow.svg"
                        width="20"
                        alt=""
                        class="me-2"
                    /></a>
                    My Activity
                  </h2>
                </div>
                <div class="col-md-6 text-end"></div>
              </div>

              <ul
                class="nav nav-pills mb-3 tab-style-1"
                id="login-tab"
                role="tablist"
                style="height: 100px"
              >
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    role="tab"
                    style="height: 100px"
                    v-on:click="$router.push('/recently-viewed')"
                    >Recently Viewed <br />profiles ({{
                      count.recently_view_count >= 0
                        ? count.recently_view_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link activ"
                    role="tab"
                    style="height: 100px"
                    v-on:click="$router.push('/shortlisted')"
                    >Shortlisted <br />({{
                      count.shortlisted_count >= 0
                        ? count.shortlisted_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/intrest-sent')"
                    >Interest Sent <br />({{
                      count.intrest_sent_count >= 0
                        ? count.intrest_sent_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/intrest-recieved')"
                    >Interest Received <br />({{
                      count.intrest_recieved_count >= 0
                        ? count.intrest_recieved_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/contacts-viewed')"
                    >Viewed Contacts <br />({{
                      count.viewed_contact_count >= 0
                        ? count.viewed_contact_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/blocked-users')"
                    >Blocked Users<br />({{
                      count.block_count >= 0 ? count.block_count : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/reported-users')"
                    >Reported Users<br />({{
                      count.report_count >= 0 ? count.report_count : " "
                    }})</a
                  >
                </li>
              </ul>

              <div class="tab-content form-style">
                <!-- Shortlisted  -->
                <div
                  class="tab-pane fade show active"
                  role="tabpanel"
                  aria-labelledby=""
                >
                  <div
                    class="border-top pt-4"
                    v-for="(data, index) in shortListed"
                    :key="index"
                  >
                    <div class="row">
                      <div class="col-lg-3 col-md-4 mb-4 position-relative">
                        <div
                          :id="'ProfileSlider1_' + index"
                          class="carousel slide profile-sider"
                          data-bs-ride="carousel"
                          data-bs-interval="false"
                        >
                          <div class="carousel-inner rounded-l cursor-pointer">
                            <div
                              v-show="data.user_images"
                              class="carousel-item"
                              v-for="(data1, index1) in data.user_images"
                              :key="index1"
                              :class="index1 == 0 ? 'active' : ' '"
                            >
                              <img
                                :src="
                                  data1.image
                                    ? data1.image
                                    : 'img/profile-holder.png'
                                "
                                class="photos"
                                alt="..."
                              />
                            </div>
                          </div>
                          <div
                            class="carousel-inner rounded-l new cursor-pointer"
                            v-if="
                              data.user_images.length == 0 ||
                              data.user_images == null
                            "
                          >
                            <div class="carousel-item active">
                              <img
                                src="img/profile-holder.png"
                                class="photos"
                                alt="..."
                              />
                            </div>
                          </div>
                          <div v-show="data.user_images.length">
                            <button
                              class="carousel-control-prev"
                              type="button"
                              :data-bs-target="'#ProfileSlider1_' + index"
                              data-bs-slide="prev"
                            >
                              <span
                                class="carousel-control-prev-icon"
                                aria-hidden="true"
                              ></span>
                              <span class="visually-hidden">Previous</span>
                            </button>
                          </div>
                          <div v-show="data.user_images.length">
                            <button
                              class="carousel-control-next"
                              type="button"
                              :data-bs-target="'#ProfileSlider1_' + index"
                              data-bs-slide="next"
                            >
                              <span
                                class="carousel-control-next-icon"
                                aria-hidden="true"
                              ></span>
                              <span class="visually-hidden">Next</span>
                            </button>
                          </div>
                        </div>
                        <div
                          class="text-center my-3 carousel-counter"
                          id="slide-counter"
                        >
                          <div class="num text-white"></div>
                        </div>
                      </div>
                      <div
                        class="col-lg-7 col-md-8 cursor-pointer"
                       
                      >
                        <div class="row">
                          <div class="col-lg-6"  v-on:click="$router.push('/profile-view/' + data.uuid)">
                            <div class="row">
                              <div class="col-6">
                                <label for="">Reg. No.</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.registration_no
                                      ? data.registration_no
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">Surname</label>
                              </div>
                              <div
                                class="col-6"
                                style="word-break: break-all !important"
                              >
                                <p class="font-medium pink-clr">
                                  <!-- {{ data.first_name ? data.first_name : "" }}
                                  {{ data.middle_name ? data.middle_name : "" }} -->
                                  {{ data.last_name ? data.last_name : "" }}
                                </p>
                              </div>
                            </div>

                            <!-- <div
                              class="row"
                              v-if="mydetail.is_membership_subscribed == 'N'"
                            >
                              <div class="col-6">
                                <label for="">Surname</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{ data.last_name ? data.last_name : "-" }}
                                </p>
                              </div>
                            </div> -->
                            <div class="row">
                              <div class="col-6">
                                <label for="">Native Place</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.native_place_district
                                      ? data.native_place_district.name
                                      : ""
                                  }}
                                  {{
                                    data.native_place_taluka
                                      ? " - " + data.native_place_taluka.name
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">DOB</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.dob
                                      ? $helperService.getFormatedDate(data.dob)
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">Height</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.height
                                      ? $helperService.getHeight(data.height)
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            
                          </div>
                          <div class="col-lg-6"  v-on:click="$router.push('/profile-view/' + data.uuid)">
                            <div class="row">
                              <div class="col-6">
                                <label for="">Education</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.education_courses
                                      ? data.education_courses
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">Occupation</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.occupation_details
                                      ? data.occupation_details
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">Ann. Inc. (Lakh)</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.annual_income ||
                                    data.annual_income == 0
                                      ? $helperService.kFormatter(data.annual_income)
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">Working city</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.working_place_taluka
                                      ? data.working_place_taluka.name
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            
                            <!-- <div class="row">
                              <div class="col-6"><label for="">Gun Milan</label></div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{ data.gan ? data.gan.name : "-" }}
                                </p>
                              </div>
                            </div> -->
                          </div>
                          <div class="text-center mt-3">
                            <p  v-on:click="$router.push('/profile-view/' + data.uuid)">
                              Shortlisted on
                              {{
                                $helperService.getFormatedDate(
                                  data.shortlist_created_at
                                )
                              }}
                            </p>
                            <button
                              type="button"
                              class="btn btn-outline-brand-1 mb-3"
                              v-on:click="removeShortlisted(data.uuid, index)"
                            >
                              <i
                                class="fa fa-minus-circle"
                                aria-hidden="true"
                              ></i>
                              Remove From Shortlisted
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-4 ps-md-0"  >
                        <!-- <button
                          v-on:click="showRemmaingtactModel(data.shortlist_id)"
                          class="btn btn-outline-brand-1 mb-3 w-100"
                        >
                          <i
                            class="fa fa-eye font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          View Contact
                        </button> -->
                        <button
                          v-if="!data.hasViewContact"
                          v-on:click="showRemmaingtactModel(data.shortlist_id)"
                          class="btn btn-outline-brand-1 mt-2 mb-3 w-100"
                        >
                          <i
                            class="fa fa-eye font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          View Contact
                        </button>
                        <button
                          v-if="data.hasViewContact"
                          v-on:click="showRemmaingtactModel(data.shortlist_id)"
                          class="btn btn-brand-1 mt-2 mb-3 w-100"
                        >
                          <i
                            class="fa fa-eye font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          View Contact
                        </button>
                        <button
                          type="button"
                          class="btn btn-brand-1 w-100 mb-3"
                          v-if="!data.hasSentIntrest"
                          v-on:click="sendIntrest(data)"
                        >
                          <i
                            class="fa fa-paper-plane font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          Send interest
                        </button>
                        <button
                          type="button"
                          class="btn btn-brand-1 w-100 mb-2"
                          v-if="data.hasSentIntrest"
                          v-on:click="notIntrested(data)"
                        >
                          <i
                            class="fa fa-paper-plane font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          Cancel Interest
                        </button>
                      </div>
                    </div>
                  </div>
                  <ErrorComponent
                    @retry="getShortListed(0)"
                    ref="errorComponent"
                  />
                  <div class="row mx-0 mb-4">
                    <div
                      class="col-lg-12 mt-5 text-right"
                      style="text-align-last: end"
                    >
                      <div class="page-bottom-pagination text-right">
                        <Pagination
                          @page-change="pageChange"
                          @items-per-page-change="itemsPerPageChange"
                          ref="listPagination"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- View Reason  -->
    <div
      class="modal fade"
      id="ViewReason"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">View Reason</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Perspiciatis asperiores repellat ipsa enim nobis! Dignissimos quod
              quo deserunt delectus animi perspiciatis aut, perferendis libero,
              voluptatem hic nemo quisquam iure. Vel.
            </p>
          </div>
        </div>
      </div>
    </div>

    <TextModal ref="viewMembershipPlan">
      <div>
        <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="row">
            <button
              type="button"
              class="btn-close"
              style="margin-left: auto; margin-top: -58px; margin-right: -10px"
              v-on:click="$refs.viewMembershipPlan.closeModal()"
            ></button>
          </div>
          <div class="form-group">
            <h4 class="text-center">You are a free member</h4>
            <p>
              Buy a paid membership to see contact no. & some hidden information
            </p>
          </div>
          <div class="text-center">
            <router-link
              to="/membership-plans"
              class="btn btn-brand-1 btn-block"
            >
              View membership plan
            </router-link>
          </div>
        </div>
      </div>
    </TextModal>
    <TextModal ref="remainingContacts">
      <div>
        <div class="row border-0 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="row">
            <button
              type="button"
              class="btn-close"
              style="margin-left: auto"
              v-on:click="$refs.remainingContacts.closeModal()"
            ></button>
          </div>
          <div class="form-group">
            <h4 class="text-center">View Contact</h4>
            <p>
              Your Total Remaining Contact View is -
              {{ remaining_contact_view_count }}
            </p>
          </div>
          <div class="text-center">
            <button
              type="button"
              class="btn btn-brand-1 w-100 mb-3"
              v-on:click="showContactModel()"
            >
              View Contact
            </button>
          </div>
        </div>
      </div>
    </TextModal>
    <!-- photo gallery  -->
    <!-- Modal -->
    <ConteactViewModel ref="ConteactViewModel" />
  </div>
</template>
<script>
import $ from "jquery";
import ErrorComponent from "@/components/ErrorComponent";
import ConteactViewModel from "@/components/ConteactViewModel";
import Pagination from "@/components/Pagination.vue";
import TextModal from "@/components/TextModal.vue";
// import moment from "moment";
//import router from "../../router";
export default {
  name: "MyActivity",
  components: {
    ErrorComponent,
    ConteactViewModel,
    Pagination,
    TextModal,
  },
  data() {
    return {
      loader: false,
      offset: 0,
      uuid: "",
      remaining_contact_view_count: 0,
      count: {},
      mydetail: {},
      shortListed1: {},
      contentDetail: {},
      shortListed: [],
    };
  },

  mounted() {
    var totalItems = $(".carousel-item").length;
    var currentIndex = $(".carousel-item.active").index() + 1;
    $(".num").html("" + currentIndex + "/" + totalItems + "");

    $("#ProfileSlider").bind("slid", function () {
      currentIndex = $(".carousel-item.active").index() + 1;
      $(".num").html("" + currentIndex + "/" + totalItems + "");
    });
    this.getActivityCount();
    this.getShortListed(0);
    this.getMeCall();
  },
  methods: {
    pageChange(offset) {
      this.getShortListed(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getShortListed(0);
    },
    getActivityCount() {
      this.$api
        .getAPI({
          _action: "/get-activity-count",
        })
        .then((res) => {
          this.count = res;
        })
        .catch(() => {});
    },
    shortlist(data) {
      var obj = {};
      if (data.user) {
        obj.to_user_id = data.user && data.user.uuid ? data.user.uuid : "";
      } else {
        obj.to_user_id = data.uuid ? data.uuid : "";
      }
      if (obj.to_user_id) {
        this.$api
          .postAPI({
            _action: "/short-list",
            _body: obj,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getActivityCount();
            return (data.hasShortListed = 1);
          })
          .catch(() => {});
      }
    },

    showRemmaingtactModel(uuid) {
      this.$refs.errorComponent.updateFormLoader(true);
      if (uuid) {
        this.uuid = uuid;
      }
      this.$api
        .getAPI({
          _action: "/remmaing-contact-detail/" + this.uuid,
        })
        .then((res) => {
          this.$refs.errorComponent.updateFormLoader(false);
          if (res.contact_view && res.contact_view > 0) {
            this.remaining_contact_view_count = res.contact_view;
            this.$refs.remainingContacts.showModal();
          } else if (res.already_viewed && res.already_viewed == 1) {
            this.contentDetail = res;
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          } else {
            this.$refs.viewMembershipPlan.showModal();
          }
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    showContactModel() {
      this.$refs.remainingContacts.closeModal();
      this.$api
        .getAPI({
          _action: "/contact-detail/" + this.uuid,
        })
        .then((res) => {
          if (res) {
            this.contentDetail = res;
            this.$refs.remainingContacts.closeModal();
            this.getShortListed(this.offset)
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          }
        })
        .catch(() => {});
    },
    getMeCall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.mydetail = res;
          this.$store.commit("setUser", res);
        })
        .catch(() => {});
    },
    sendIntrest(data) {
      var obj = {};
      obj.to_user_id = data.uuid ? data.uuid : "";
      this.$api
        .postAPI({
          _action: "/send-intrest",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.getActivityCount();
          return (data.hasSentIntrest = 1);
        })
        .catch(() => {});
    },
    notIntrested(data) {
      var obj = {};
      obj.to_user_id = data.uuid ? data.uuid : "";
      this.$api
        .putAPI({
          _action: "/cancel-request/" + obj.to_user_id,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (data.hasSentIntrest = 0);
        })
        .catch(() => {});
    },
    // notIntrested(data) {
    //   var obj = {};
    //   obj.to_user_id = data.uuid ? data.uuid : "";
    //   this.$api
    //     .putAPI({
    //       _action: "/cancel-request/" + obj.to_user_id,
    //     })
    //     .then((res) => {
    //       this.$notify({
    //         type: "success",
    //         text: res.message,
    //       });
    //       this.getActivityCount();
    //       return (data.hasSentIntrest = 0);
    //     })
    //     .catch(() => {});
    // },
    getShortListed(offset) {
      this.loader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateListLoader(true);
      }

      var obj = {};
      if (offset == 0) {
        this.shortListed = [];
      }
      obj.offset = offset;
      this.$api
        .getAPI({
          _action: "/profile/short-listed/list",
          _body: obj,
        })
        .then((res) => {
          this.loader = false;
          this.shortListed = res.list;
          this.offset = res.next_offset;
          if (offset == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "Shortlisted Not Available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          this.$refs.errorComponent.updateListLoader(false);
        });
    },
    removeShortlisted(id, index) {
      var obj = {};
      if (id) {
        obj.to_user_id = id;
      } else {
        return;
      }
      if (obj.to_user_id) {
        this.$api
          .putAPI({
            _action: "/remove-shortlist/" + obj.to_user_id,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getActivityCount();
            this.shortListed.splice(index, 1);
          })
          .catch(() => {});
      }
    },
  },
};
</script>
